import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { TagsServiceProvider } from '../../api/tags'

const TagsService = TagsServiceProvider()
const name = 'getTag'

export default (tagId) => (asyncAction(
  name,
  TagsService.getTag,
  { tagId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/tags/getTag.js